/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 10b70efd47036b72e8d1dec5d12405f81f712e3a
 */

/**
 * Reasons a segment may be rejected during server-side validation.
 */
export type SegmentErrorReason = typeof SegmentErrorReason[keyof typeof SegmentErrorReason];


export const SegmentErrorReason = {
  invalid_progression_range: 'invalid_progression_range',
  invalid_segment_order: 'invalid_segment_order',
  segment_too_long: 'segment_too_long',
  invalid_timestamp: 'invalid_timestamp',
  unknown_product: 'unknown_product',
} as const;
